import React from 'react';

import { useNarrativeTextInput } from '../hooks/useNarrativeTextInput';

interface ConditionalTextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  label?: string;
  maxLength?: number;
}

export const ConditionalTextInput = React.memo(function ConditionalTextInput({
  value,
  onChange,
  placeholder,
  className,
  label,
  maxLength,
}: ConditionalTextInputProps) {
  const {
    value: localValue,
    onChange: handleChange,
    error,
  } = useNarrativeTextInput(value, onChange, 300, maxLength);

  return (
    <div>
      {label && <label className="text-gray-400 text-xs">{label}</label>}
      <textarea
        value={localValue}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        className={className}
      />
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
    </div>
  );
});
